// translations
const i18n = require("i18n-js")

// EN
const adminEn = require("@phrase/locales/admin.en.yml").en
const activityEn = require("@phrase/locales/activity.en.yml").en
const contactEn = require("@phrase/locales/contact.en.yml").en
const dashboardEn = require("@phrase/locales/dashboard.en.yml").en
const fieldsEn = require("@phrase/locales/fields.en.yml").en
const invoiceEn = require("@phrase/locales/invoice.en.yml").en
const modelsEn = require("@phrase/locales/models.en.yml").en
const messagingEn = require("@phrase/locales/messaging.en.yml").en
const notificationEn = require("@phrase/locales/notification.en.yml").en
const performanceEn = require("@phrase/locales/performance.en.yml").en
const planningEn = require("@phrase/locales/planning.en.yml").en
const productEn = require("@phrase/locales/product.en.yml").en
const settingsEn = require("@phrase/locales/settings.en.yml").en
const statisticsEn = require("@phrase/locales/statistics.en.yml").en
const transportEn = require("@phrase/locales/transport.en.yml").en
const utilitiesEn = require("@phrase/locales/utilities.en.yml").en
const mailersEn = require("@phrase/locales/mailers.en.yml").en
const policyEn = require("@phrase/locales/policy.en.yml").en
const publicEn = require("@phrase/locales/public.en.yml").en

// FR
const utilitiesFr = require("@phrase/locales/utilities.fr.yml").fr
const publicFr = require("@phrase/locales/public.fr.yml").fr

// Concat
const translations = {
  en: {
    ...activityEn,
    ...adminEn,
    ...contactEn,
    ...dashboardEn,
    ...fieldsEn,
    ...invoiceEn,
    ...modelsEn,
    ...messagingEn,
    ...notificationEn,
    ...performanceEn,
    ...planningEn,
    ...productEn,
    ...settingsEn,
    ...statisticsEn,
    ...transportEn,
    ...utilitiesEn,
    ...mailersEn,
    ...policyEn,
    ...publicEn
  },
  fr: {
    ...utilitiesFr,
    ...publicFr
  }
}

i18n.translations = translations

module.exports = i18n
